import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router'
import WidgetBox from '../../components/widgets/WidgetBox'
import Switch from '../../components/ui/Switch'
import { selectIsUserLoggedIn } from '../../selectors/userSelector'
import { selectAllTagsItems } from '../../selectors/tagsSelector'
import './personalItemsInstructions.pcss'
import { fetchAllTags } from '../../components/item/tagsActions'

const PersonalItemsInstructions = () => {
  const loggedIn = useSelector(selectIsUserLoggedIn)
  const allTags = useSelector(selectAllTagsItems).sort((a, b) => b.get('whiteListedCount') - a.get('whiteListedCount')).toArray()
  const dispatch = useDispatch()

  // Loading tags on mount only, no SSR or refetches needed
  useEffect(() => {
    dispatch(fetchAllTags())
  }, [dispatch])

  return (
    <section className='content content_padded personal-items-instructions'>
      <div className='personal-items-instructions__row'>
        <div className='personal-items-instructions__column'>
          <h2 className='personal-items-instructions__heading'>Juuri sinulle tärkeät aiheet</h2>
        </div>
        <div className='personal-items-instructions__column'>
          { loggedIn ?
            <p className='personal-items-instructions__text'>
              Omat aiheet on näkymä, jossa sinä päätät, mitä uutisia näet.
              Aloita valitsemalla profiilin asetuksista aiheita, jotka kiinnostavat sinua.
              Voit seurata mitä tahansa aihetta avaamalla valikko aiheen tai kategorian vieressä olevalla
              <span className='fa fa-ellipsis-v text-icon' />-merkillä ja valitsemalla seuraa. Voit myös lisätä listaan
              omia lähteitä <Link to='/asetukset/omat-syotteet'>Omat syötteet -asetussivulla</Link>
            </p>
            :
            <p className='personal-items-instructions__text'>
              Omat aiheet on näkymä, jossa sinä päätät, mitä uutisia näet.
              Selaa Amppareiden uutislistoja ja Pinnalla-boksia ja lisää aiheita Omiin
              aiheisiin avaamalla valikko aiheen tai kategorian vieressä olevalla
              <span className='fa fa-ellipsis-v text-icon' />-merkillä ja valitsemalla seuraa. Kirjautuneena käyttäjänä voit
              myös lisätä Omat aiheet -listaan omia lähteitä.
            </p>
          }
        </div>
      </div>
      <div className='personal-items-instructions__row'>
        <WidgetBox title='Suosittuja aiheita'>
          { allTags.slice(0, 10).map(tag => (
            <Switch key={ tag.get('id') } tag={ tag } />
          )) }
        </WidgetBox>
      </div>
    </section>
  )
}

export default PersonalItemsInstructions
